import { paperClasses } from '@mui/material/Paper';
import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiCard = {
  styleOverrides: {
    root: ({ theme }) => ({
      border: '1px solid var(--mui-palette-divider)',
      borderRadius: '12px',
      backgroundColor: 'var(--mui-palette-background-paper)',
      [`&.${paperClasses.elevation1}`]: { boxShadow: theme.shadows[1] },
    }),
  },
} satisfies Components<Theme>['MuiCard'];
